<div class="d-flex justify-content-end" *ngIf="isMarketplace">
	<div class="text-right">
		<button class="btn btn-success mr-md-5 mb-1" (click)="openModalBlogForm(modalBlogForm)">
			<i class="fa-solid fa-plus"></i> New Post
		</button>
	</div>
</div>
<section *ngIf="!checkShopAndEmpty()"
	class="item_details owl_nav_blue pt-0 {{shop_template}} {{ isMarketplace ? 'marketplace-container' : '' }}">
	<div class="container-fluid px-md-5 px-lg-5 px-0">
		<!-- <h6 class="px-4">POPULAR NOW</h6> -->

		<section class=" py-1">
			<div class="row px-md-0 px-lg-2 px-md-2 px-2 mt-md-4 mt-lg-4 my-3 ">
				<div class="d-flex justify-content-between flex-md-row flex-column w-100 px-2">
					<span class="bg-green px-3 py-2 fw-bolder rounded" *ngIf="!isMarketplace"
						style="font-weight: 600;">NEWS AND
						PROMO</span>
					<div class="btn-group mx-0 px-0" *ngIf="isMarketplace">
						<button *ngFor="let row of categories" (click)="filterByCategory(row)"
							class="btn btn-sm btn-{{ row == category ? 'purple' : 'light' }}">{{ row }}</button>
					</div>
					<div class="d-flex mt-2 justify-content-end">
						<span class="my-auto fw-bolder" style="font-weight: 600; font-size: 1.3em;">Popular</span>
						<div class="d-flex ml-1">
							<button class="btn btn-sm btn-light rounded-0 rounded-left" (click)="prev()"><i
									class="fa-solid fa-chevron-left" style="cursor: pointer;"></i></button>
							<button class="btn btn-sm btn-light rounded-0 rounded-right" (click)="next()"><i
									class="fa-solid fa-chevron-right" style="cursor: pointer;"></i></button>
						</div>
					</div>
				</div>
			</div>
			<p class="coming_soon" *ngIf="get_bottom_banner_response_filter.length == 0"><img loading="lazy"
					src="../../../assets/images/new/coming-soon.png"></p>
			<owl-carousel-o [options]="customOptions"
				*ngIf="get_bottom_banner_response_filter && get_bottom_banner_response_filter.length > 0">
				<ng-template class="slide h-100" carouselSlide *ngFor="let i of get_bottom_banner_response_filter">
					<div class="card mr-1 h-100">
						<div class="card-body p-0 h-100">
							<div class="bg-white">
								<div class="my-auto aspect-ratio-container">
									<img loading="lazy" src="{{ imgUrl + i.image }}" class="card-img-top my-auto" alt="...">
								</div>
							</div>
							<div class="p-3 h-100" *ngIf="!isMarketplace">
								<h5 class="card-title">{{ i.title }}</h5>
								<div class="ad_info">
									<div class="ad_time">
										<i class="fa fa-clock"></i> {{ convertDate(i.created) }}
									</div>
									<div class="ad_author">
										<i class="fa fa-user"></i> {{ i.author }}
									</div>
									<div class="ad_author" *ngIf="isMarketplace">
										<i class="fa fa-heart"></i> {{ i.bottomBannerLikes?.length }}
									</div>
								</div>
								<p class="card-text" style="height: 90px;"
									[innerHTML]="i.text?.length > 80 ? i.text?.substr(0, 80) + '...' : i.text?.substr(0, 80)">
								</p>
								<ng-container *ngIf="isMarketplace">
									<button class="btn btn-purple w-100" (click)="openDetailBlog(detailBlog, i)">READ
										MORE</button>
								</ng-container>
								<ng-container *ngIf="!isMarketplace">
									<div class="ad_read_more">
										<button class="btn btn-purple" (click)="openDetailBlog(detailBlog, i)">READ
											MORE</button>
									</div>
								</ng-container>
							</div>
							<div class="p-3 h-100" *ngIf="isMarketplace">
								<h5 class="card-title text-purple">{{ i.title }}</h5>
								<p style="height: 45px;"
									[innerHTML]="i.text?.length > 80 ? i.text?.substr(0, 80) + '...' : i.text?.substr(0, 80)">
								</p>
								<div class="ad_info py-2">
									<div class="ad_time">
										<i class="fa fa-clock"></i> {{ convertDate(i.created) }}
									</div>
									<div class="ad_author">
										<i class="fa fa-user"></i> {{ i.author }}
									</div>
									<div class="ad_author" *ngIf="isMarketplace">
										<i class="fa fa-heart"></i> {{ i.bottomBannerLikes?.length }}
									</div>
								</div>
								<ng-container *ngIf="isMarketplace">
									<button class="btn btn-purple w-100" (click)="openDetailBlog(detailBlog, i)">READ
										MORE</button>
								</ng-container>
								<ng-container *ngIf="!isMarketplace">
									<div class="ad_read_more">
										<button class="btn btn-purple" (click)="openDetailBlog(detailBlog, i)">READ
											MORE</button>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</ng-template>
			</owl-carousel-o>
		</section>
	</div>
</section>

<div *ngIf="isMarketplace" id="articles">
	<div class="bg-white px-md-5 pb-5 pt-0">
		<div class="container-fluid text-left">

			<div class="row px-md-0 px-lg-2 px-md-2 mt-md-4 mt-lg-4 my-3 ">
				<div class="d-flex justify-content-end w-100 px-3">
					<span class="my-auto fw-bolder" style="font-weight: 600; font-size: 1.3em;">Latest</span>
				</div>
			</div>
			<div class="row">

				<div class="col-md-8 px-md-0">
					<p class="coming_soon" *ngIf="get_bottom_banner_response_latest.length == 0"><img loading="lazy"
							src="../../../assets/images/new/coming-soon.png"></p>
					<ng-container *ngFor="let i of get_bottom_banner_response_latest; let index = index">
						<div class="card mb-3" *ngIf="index < 3">
							<div class="row no-gutters">
								<div class="col-md-4">
									<img loading="lazy" src="{{ imgUrl + i.image }}" class="my-auto" alt="...">
								</div>
								<div class="col-md-8">
									<div class="card-body">
										<h5 class="text-purple">News</h5>
										<h6>{{ i.title }}</h6>
										<p class="card-text" style="height: 45px;"
											[innerHTML]="i.text?.length > 80 ? i.text?.substr(0, 80) + '...' : i.text?.substr(0, 80)">
										</p>
										<div class="ad_info">
											<div class="ad_time">
												<i class="fa fa-clock"></i> {{ convertDate(i.created) }}
											</div>
											<div class="ad_author">
												<i class="fa fa-user"></i> {{ i.author }}
											</div>
											<div class="ad_author" *ngIf="isMarketplace">
												<i class="fa fa-heart"></i> {{ i.bottomBannerLikes?.length }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="col-md-4">
					<img loading="lazy" src="{{ imgUrl + ( get_bottom_banner_response && get_bottom_banner_response.length > 0 ? get_bottom_banner_response[0].image : '') }}"
						class="mb-1" alt="...">
					<img loading="lazy" src="{{ imgUrl + ( get_bottom_banner_response && get_bottom_banner_response.length > 0 ? get_bottom_banner_response[0].image : '') }}"
						class="mb-1" alt="...">
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #detailBlog let-modal>
	<div class="modal-blog">
		<div class="modal-header">
			<div class="d-flex justify-content-between w-100">
				<div class="d-flex">
					<ng-container *ngIf="isMarketplace">
						<span (click)="likeHandle(detail?.id, detail)" class="text-salmon my-auto pr-2"
							style="font-size: 20px;">
							<i
								class="fa-{{ hasChecked(detail?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
						</span>
					</ng-container>
					<h2>BLOG INFO</h2>
				</div>
				<img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modalService.dismissAll()" />
			</div>
		</div>
		<div class="modal-body bottom_img_div">

			<div class="bottom_img" [style.backgroundImage]="'url(' + imgUrl + detail.image + ')'"
				(click)="navigateToUrl(detail.url)">
			</div>
			<p class="bottom_banner_text">{{detail.title}}</p>
			<div class="ad_info">
				<div class="ad_time">
					<i class="fa fa-clock"></i> {{ convertDate(detail.created) }}
				</div>
				<div class="ad_author">
					<i class="fa fa-user"></i> {{ detail.author != '' ? detail.author : 'Anonymous' }}
				</div>
			</div>

			<div class="ad_description" [innerHTML]="detail.text">
			</div>

		</div>
	</div>
</ng-template>

<ng-template #modalBlogForm let-modal>
	<div class="modal-content">
		<div class=""></div>
		<div class="modal-body">
			<div class="row">
				<div class="col-md-12 d-flex">
					<div class="ml-auto">
						<h3>Form Blog</h3>
					</div>
					<div class="ml-auto">
						<i (click)="modalService.dismissAll()" class="fa fa-window-close pointer"
							aria-hidden="true"></i>
					</div>
				</div>
			</div>
			<div class="edit_cat_modal col-md-12 mx-auto">
				<div class="row">
					<div class="col-md-12">
						<form [formGroup]="bottomImagesForm">
							<div class="form-group col-md-6 mx-auto prod_upld">
								<input formControlName="banner" type="file" #banner
									(change)="onBottomBannerSelected(banner.files, $event)" accept="image/*" />
								<img loading="lazy" src="../../../assets/images/uploadd1.png" *ngIf="blogImageUrl == ''"
									class="food_img bottom_banner_img" />
								<img loading="lazy" src="{{blogImageUrl}}" *ngIf="blogImageUrl != ''" class="food_img">
								<ng-container *ngIf="submitted && bottomBannerControl.banner.errors">
									<p class="error-message" style="padding: 0px; font-size: 12px"
										*ngIf="bottomBannerControl.banner.errors.required">
										Please select image
									</p>
								</ng-container>
							</div>

							<div class="form-group">
								<label>Title</label>
								<input type="text" class="form-control" formControlName="title">
								<ng-container *ngIf="submitted && bottomBannerControl.title.errors">
									<p class="error-message" style="padding: 0px; font-size: 12px"
										*ngIf="bottomBannerControl.title.errors.required">
										Please enter title
									</p>
								</ng-container>
							</div>
							<div class="form-group">
								<label>Text</label>
								<app-editor [(innerValue)]="ckEditorText"></app-editor>
								<ng-container *ngIf="submitted">
									<p class="error-message" style="padding: 0px; font-size: 12px"
										*ngIf="ckEditorText == ''">
										Please enter text
									</p>
								</ng-container>
							</div>
							<div class="form-group">
								<label>Author</label>
								<input type="text" class="form-control" formControlName="author">
								<ng-container *ngIf="submitted && bottomBannerControl.author.errors">
									<p class="error-message" style="padding: 0px; font-size: 12px"
										*ngIf="bottomBannerControl.author.errors.required">
										Please enter author
									</p>
								</ng-container>
							</div>
							<div class="form-group">
								<label>Section</label>
								<select formControlName="category" id="" class="form-control">
									<option value="" selected disabled>Select Section</option>
									<option *ngFor="let val of categories" [value]="val">{{ val }}</option>
								</select>
								<ng-container *ngIf="submitted && bottomBannerControl.category.errors">
									<p class="error-message" style="padding: 0px; font-size: 12px"
										*ngIf="bottomBannerControl.category.errors.required">
										Please enter Section
									</p>
								</ng-container>
							</div>

							<!-- <div class="form-group">
                                <label>URL</label>
                                <input type="text" class="form-control" formControlName="url">
                                <ng-container *ngIf="submitted && bottomBannerControl.url.errors">
                                    <p class="error-message" style="padding: 0px; font-size: 12px"
                                        *ngIf="bottomBannerControl.url.errors.required">
                                        Please enter URL
                                    </p>
                                </ng-container>
                            </div> -->

							<div class="d-flex justify-content-center" style="padding: 4px; width: 100%;">
								<button (click)="addBottomBanner()" class="btn btn-success"> <i
										class="fa-solid fa-save"></i> Submit </button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>